import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import handleValidation from "../../../Validation";

class AcademyForm extends Component {
  constructor() {
    super();
    this.state = {
      firstName: "",
      email: "",
      company: "",
      team: "",
      contact: ""
    };
  }

  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value,
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] === true) {
      document.getElementById("academy").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("academy").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="question-form-section section-padding">
        <Container>
          <Row className='justify-content-center'>
            <Col xs={{ size: 12 }} md={{ size: 8}}>
              <Row className="have-questions-form">
                <Col sm={{ size: 12 }}>
                  <h1 className="mt-5 mb-3 text-center">{this.props.title}</h1>
                  <hr className="heading-underline mb-5" />
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 5 }}>
                  <h3>{this.props.textTitle}</h3>
                  <p className="question-form-text">{this.props.text}</p>
                  <p className="question-form-text">
                    <FontAwesome
                      className="map-marker-alt"
                      name="map-marker-alt"
                    />{" "}
                    3550 Lenox Rd NE Suite 2100
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="phone" name="phone" />
                    404-474-4774
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="envelope" name="envelope" />{" "}
                    info@itslighthouse.com
                  </p>
                </Col>

                <Col className="white" sm={{ size: 7 }}>
                  <form
                    id="academy"
                    action=""
                    method=""
                    onSubmit={this.submitDetails.bind(this)}
                  >
                    <input type="hidden" name="lead_source" value="Website" />
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value={this.props.academySource}
                    />

                    <input
                      type="hidden"
                      name="retURL"
                      value="https://atlighthouse.com/thank-you"
                    />
                    <Row>
                      <Col sm={{ size: 6 }}>
                        <label
                          className="apply-now-labels"
                          htmlFor="first_name"
                        >
                          Name<p className="required-symbol">{"*"}</p>
                        </label>
                        <input
                          id="first_name"
                          maxLength="40"
                          name="first_name"
                          size="20"
                          type="text"
                          className="input-form form-control"
                          ref="first_name"
                          placeholder="First Name"
                        />

                        {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["first_name"]}
                          </span>
                        ) : (
                          ""
                        )}

                        <br />
                      </Col>
                      <Col sm={{ size: 6 }}>
                        <label className="apply-now-labels" htmlFor="email">
                          Email<p className="required-symbol">{"*"}</p>
                        </label>
                        <input
                          id="email"
                          maxLength="80"
                          name="email"
                          size="20"
                          type="email"
                          className="input-form form-control"
                          ref="email"
                          placeholder="Email"
                        />
                        {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["email"]}
                          </span>
                        ) : (
                          ""
                        )}
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col sm={{ size: 6 }}>
                        <label className="apply-now-labels" htmlFor="full_name">
                          Company
                        </label>
                        <input
                          id="company_name"
                          maxLength="60"
                          name="company_name"
                          className="input-form form-control"
                          size="20"
                          type="text"
                          ref="company_name"
                          placeholder="Company Name"
                        />
                        <br />
                      </Col>
                      <Col sm={{ size: 6 }}>
                        <label className="apply-now-labels" htmlFor="full_name">
                          Team
                        </label>
                        <input
                          id="team_size"
                          maxLength="60"
                          name="full_name"
                          className="input-form form-control"
                          size="20"
                          type="number"
                          ref="team_size"
                          placeholder="Team Size Ex. 10"
                        />
                        <br />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <label
                          className="apply-now-labels"
                          htmlFor="exampleSelect"
                        >
                          Which training are you interested in?
                        </label>
                        <select
                          id=""
                          name=""
                          title="Which course are you applying for?"
                          className="apply-now-inputs form-control"
                        >
                          <option value=""></option>
                          <option value="Introduction to AWS">
                            Introduction to AWS
                          </option>
                          <option value="AWS Certified Training">
                            AWS Certified Training
                          </option>
                          <option value="Cybersecurity Certified Training">
                            Cybersecurity Certified Training
                          </option>
                        </select>
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label
                          className="apply-now-labels"
                          htmlFor="exampleSelect"
                        >
                          When are you looking to start training?
                        </label>
                        <select
                          id="00N3i00000Bkld5"
                          name="00N3i00000Bkld5"
                          title="Which course are you applying for?"
                          className="apply-now-inputs form-control"
                        >
                          <option value=""></option>
                          <option value="Immediate">Immediate</option>
                          <option value="One to three months">
                            One to three months
                          </option>
                          <option value="Three to six months">
                            Three to six months
                          </option>
                          <option value="Six months to one year">
                            Six months to one year
                          </option>
                          <option value="Not sure">Not sure</option>
                        </select>
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label className="apply-now-labels" htmlFor="message">
                          Message
                        </label>
                        <textarea
                          id="00N3i00000Bklln"
                          name="00N3i00000Bklln"
                          rows="6"
                          type="text"
                          wrap="soft"
                          className="apply-now-inputs form-control"
                          placeholder="Let us know any questions and requests you have"
                        ></textarea>
                        <br />
                      </Col>
                    </Row>

                    <div>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn-secondary"
                      />
                    </div>
                  </form>
                  <p className="privacy-terms mt-0">
                    <i>
                      By providing your email, you agree to our{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/privacy-policy">
                          privacy policy
                        </Link>
                      </u>{" "}
                      and{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/terms-of-service">
                          terms of conditions
                        </Link>
                      </u>
                    </i>
                    .
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(AcademyForm);
